import React from 'react';
import {
  getFocusPriorityMaxCount,
  normalizeFocusPriority,
} from '../utils/focusPriority';

const FocusPrioritySlide = ({
  title,
  subtitle,
  selectedFocusAreas,
  priorityValue,
  onChange,
}) => {
  const maxCount = getFocusPriorityMaxCount(selectedFocusAreas);
  const normalizedPriority = normalizeFocusPriority(priorityValue, selectedFocusAreas);
  const priorityByName = new Map(normalizedPriority.map((item) => [item.name, item]));

  const handleRank = (option) => {
    const existingPriority = priorityByName.get(option.name);
    if (existingPriority) {
      onChange(normalizedPriority.filter((item) => item.name !== option.name));
      return;
    }

    if (normalizedPriority.length >= maxCount) return;

    onChange([
      ...normalizedPriority,
      {
        rank: normalizedPriority.length + 1,
        name: option.name,
        label: option.label,
        answerCode: option.answerCode,
      },
    ]);
  };

  return (
    <div>
      <h2
        className="t-font-serif t-text-[28px] md:t-text-3xl t-leading-tight t-text-navy t-mb-[10px] t-m-0"
        dangerouslySetInnerHTML={{ __html: title }}
      />

      {subtitle && (
        <p className="t-text-[13px] t-leading-relaxed t-text-g500 t-mb-5">
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </p>
      )}

      <div className="t-flex t-flex-col t-gap-2">
        {selectedFocusAreas.map((option) => {
          const priority = priorityByName.get(option.name);
          const isSelected = !!priority;
          const icon = option.img ? (
            <img
              src={`${process.env.REACT_APP_PUBLIC_URL}${option.img}`}
              alt=""
              className="t-w-5 t-h-5 t-object-contain"
            />
          ) : null;

          return (
            <button
              key={option.name}
              type="button"
              className={`t-w-full t-flex t-items-center t-gap-3 t-px-4 t-py-3.5 t-border-2 t-rounded-xl t-bg-white t-cursor-pointer t-text-left t-font-sans t-text-[14.5px] t-font-medium t-text-navy t-outline-none t-min-h-[52px] t-transition-[background-color,border-color,box-shadow,transform] t-duration-200 t-ease-out [@media(hover:hover)]:hover:t-border-quiz-teal/25 [@media(hover:hover)]:hover:t-bg-quiz-teal/[.07] active:t-scale-[.988] ${
                isSelected
                  ? 't-border-quiz-teal t-bg-quiz-teal/[.07] t-shadow-[0_0_0_1px_#116D6E]'
                  : 't-border-g200'
              }`}
              onClick={() => handleRank(option)}
            >
              <span
                className={`t-w-6 t-h-6 t-min-w-[24px] t-flex t-items-center t-justify-center t-rounded-full t-border-2 t-text-xs t-font-bold t-transition-all t-duration-150 ${
                  isSelected
                    ? 't-border-quiz-teal t-bg-quiz-teal t-text-white'
                    : 't-border-g300 t-bg-transparent t-text-g300'
                }`}
              >
                {priority?.rank || ''}
              </span>
              <span className="t-flex-1" dangerouslySetInnerHTML={{ __html: option.label }} />
              {icon && <span className="t-w-6 t-flex t-justify-center">{icon}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(FocusPrioritySlide);
